module.exports = __webpack_public_path__ + "img/cju_gallery0.28c75001.jpg";